// extracted by mini-css-extract-plugin
export default {"CopyJobLinkButton":"styles_CopyJobLinkButton__HfK9V"};